(function () {
  // bbWK52PromoTag and bbWK52PromoMultiplier are injected by Liquid in the section template.
  var promoTag = window.bbWK52PromoTag;
  var promoMultiplier = window.bbWK52PromoMultiplier || 0.5;
  var tagCache = Object.create(null); // handle → true | false

  function getHandleFromCard(card) {
    var link = card.querySelector('.ns-details > a');
    if (!link) return null;
    var match = link.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function applyPromoPrice(card) {
    if (card.dataset.bbPromoApplied) return;

    var priceEl = card.querySelector('.ns-details .ns-price');
    if (!priceEl) return;

    var priceText = priceEl.textContent.trim();
    var match = priceText.match(/([\D]*)(\d+(?:\.\d+)?)(.*)/);
    if (!match) return;

    var prefix = match[1];
    var amount = parseFloat(match[2]);
    var suffix = match[3];
    var promoAmount = Math.round(amount * promoMultiplier);

    var existingStrike = card.querySelector('.ns-list-price, .ns-original-price, s, del');

    // Save original price so we can restore it if the swatch changes product
    card.dataset.bbPromoOriginalPrice = priceText;

    observer.disconnect();
    if (existingStrike) {
      priceEl.textContent = prefix + promoAmount + suffix;
    } else {
      priceEl.innerHTML =
        '<s style="opacity:0.6">' + priceText + '</s>' +
        ' ' + prefix + promoAmount + suffix;
    }
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

    card.dataset.bbPromoApplied = '1';
  }

  function resetCard(card) {
    if (card.dataset.bbPromoApplied) {
      var priceEl = card.querySelector('.ns-details .ns-price');
      if (priceEl) {
        if (card.dataset.bbPromoOriginalPrice) {
          priceEl.textContent = card.dataset.bbPromoOriginalPrice;
        } else {
          // Fallback: extract original from our injected <s> markup
          var sEl = priceEl.querySelector('s[style*="opacity:0.6"]');
          if (sEl) priceEl.textContent = sEl.textContent.trim();
        }
      }
    }
    delete card.dataset.bbPromoApplied;
    delete card.dataset.bbPromoChecking;
    delete card.dataset.bbPromoOriginalPrice;
    delete card.dataset.bbPromoHandle;
  }

  function checkCard(card) {
    if (card.dataset.bbPromoApplied || card.dataset.bbPromoChecking) return;
    if (!promoTag) return;

    var handle = getHandleFromCard(card);
    if (!handle) return;

    // Track which product this card is showing so mutations can detect
    // when a swatch swap changes it to a different product
    card.dataset.bbPromoHandle = handle;

    if (tagCache[handle] === true) { applyPromoPrice(card); return; }
    if (tagCache[handle] === false) return;

    card.dataset.bbPromoChecking = '1';
    var checkingHandle = handle;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        delete card.dataset.bbPromoChecking;
        // Bail if the card has since switched to a different product
        if (getHandleFromCard(card) !== checkingHandle) return;
        var isPromo = Array.isArray(data.tags) && data.tags.indexOf(promoTag) !== -1;
        tagCache[handle] = isPromo;
        if (isPromo) applyPromoPrice(card);
      })
      .catch(function () {
        delete card.dataset.bbPromoChecking;
        tagCache[handle] = false;
      });
  }

  function processGrid() {
    document.querySelectorAll('#ns-product-grid .ns-product').forEach(checkCard);
  }

  // Queues a card for reset+recheck if its displayed product handle has
  // changed since we last ran checkCard on it (i.e. a swatch was clicked)
  function flagIfProductChanged(card, queue) {
    if (queue.indexOf(card) !== -1) return;
    var currentHandle = getHandleFromCard(card);
    if (currentHandle && card.dataset.bbPromoHandle && currentHandle !== card.dataset.bbPromoHandle) {
      queue.push(card);
    }
  }

  var target = document.querySelector('#ns-product-grid') || document.body;
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = false;
    var cardsToReset = [];

    mutations.forEach(function (m) {
      if (m.type === 'childList') {
        Array.from(m.addedNodes).forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (
            (n.classList && n.classList.contains('ns-product')) ||
            (n.querySelector && n.querySelector('.ns-product'))
          ) {
            hasNewCards = true;
          } else if (n.closest) {
            var card = n.closest('.ns-product');
            if (card) flagIfProductChanged(card, cardsToReset);
          }
        });
      }

      // href change on the product detail link = swatch swap
      if (m.type === 'attributes' && m.attributeName === 'href' && m.target.closest) {
        var isProductLink = m.target.tagName === 'A' &&
                            m.target.parentNode &&
                            m.target.parentNode.classList.contains('ns-details');
        if (isProductLink) {
          var card = m.target.closest('.ns-product');
          if (card) flagIfProductChanged(card, cardsToReset);
        }
      }
    });

    if (hasNewCards) processGrid();

    if (cardsToReset.length > 0) {
      observer.disconnect();
      cardsToReset.forEach(resetCard);
      observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      cardsToReset.forEach(checkCard);
    }
  });
  observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  processGrid();
})();
